(() => {
  if (window.rsLoadingInitialized) return;
  window.rsLoadingInitialized = true;
  const selector = '.card__media .media, .product__media, .rs-card__image-wrapper';
  const watched = new WeakSet();
  const scan = (root) => {
    const containers = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) containers.push(root);
    if (root.matches?.('img') && root.parentElement.matches(selector)) containers.push(root.parentElement);
    containers.forEach((container) => {
      const img = container.querySelector('img');
      if (!img || watched.has(img)) return;
      watched.add(img);
      if (img.complete) return;
      container.classList.add('rs-image-pending');
      const done = () => {
        container.classList.remove('rs-image-pending');
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
      };
      img.addEventListener('load', done);
      img.addEventListener('error', done);
      if (img.complete) done();
    });
  };
  scan(document);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === 1) scan(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();
